import { apiSlice } from "../apiSlice";

const roadApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getRoadList: builder.query({
            query: (id) => {
                return {
                    url: `/api/admin/road/list?upazila=${id}`,
                    method: "GET",
                };
            },
            providesTags: ['roadList']
        }),
    }),
    overrideExisting: true,
});

export const { useGetRoadListQuery } = roadApiSlice;
